import { EventBusKey } from "@vueuse/core";
import { AmendmentOptionTypeEnum } from "../enums";
import { BookingSummary } from "../www/store/BookingSummary";

export const amendmentDialogKey: EventBusKey<AmendmentOptions> = Symbol()

export interface AmendmentOptions {
    // eslint-disable-next-line
    callback: (step: number, amendmentType: AmendmentOptionTypeEnum) => Promise<unknown>;
    isEditable: boolean;
    booking: BookingSummary;
}

export enum DialogType {
    Danger = "danger",
    Info = "info",
    Redirect = "redirect",
    Warning = "warning"
}